import { render, staticRenderFns } from "./PureRouterView.vue?vue&type=template&id=8cffd95e&"
import script from "./PureRouterView.vue?vue&type=script&lang=ts&"
export * from "./PureRouterView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports